<ng-container [ngSwitch]="view">

  <ng-container *ngSwitchCase="'simple'">
    <ng-container *ngTemplateOutlet="simple"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'full'">
    <ng-container *ngTemplateOutlet="full"></ng-container>
  </ng-container>
</ng-container>

<ng-template #simple>
  <div class="account {{view}}"
       [class.expired]="accountExpire"
       [class.test]="isTestCard"
       [class.selected]="selected" (click)="selectAcc()">
    <div *ngIf="accountExpire" class="account__expired">{{'finance-page.card.expiry-text' | customLocale}}</div>

    <div *ngIf="isTestCard" class="test-card-label">
      {{'profile-steps.test-bank-card' | customLocale}}
    </div>

    <div class="data">
      {{accountLabel}}
    </div>
    <div class="icon">
      <app-icon width="32" height="32" file="card-types" [icon]="accountType"></app-icon>
    </div>
  </div>
</ng-template>

<ng-template #full>
  <div class="account {{view}}" [class.expired]="accountExpire"
       [class.test]="isTestCard"
       [class.selected]="selected" (click)="selectAcc()">
    <div *ngIf="isTestCard" class="test-card-label">
      {{'profile-steps.test-bank-card' | customLocale}}
    </div>
    <div *ngIf="accountExpire" class="account__expired">{{'finance-page.card.expiry-text' | customLocale}}</div>
    <div class="account__details">
      <div class="card-type-icon">
        <app-icon width="80" height="80" file="card-types" [icon]="accountType"></app-icon>
      </div>

      <div class="info">
        <div class="info__type bold">
          <span>{{ accountLabel }}</span>
        </div>
        <div class="info__expiration">
          {{'finance-page.card.expiry-date' | customLocale}}:
          <span>{{ accountExpirationMY }}</span>
        </div>
      </div>
    </div>
    <div class="account__actions">
      <div *ngIf="!isDefault" [class.disabled]="accountExpire"
           data-test="set-default"
           class="link card-not-default" (click)="setDefault()">{{'finance-page.card.set-as-main' | customLocale}}</div>
      <div *ngIf="isDefault" [class.disabled]="accountExpire"
           data-test="is-default"
           class="link card-default">{{'finance-page.card.main-card' | customLocale}}</div>
      <div class="link link-delete"
           data-test="delete-card"
           (click)="deleteAccount()">{{ 'finance-page.card.remove' | customLocale }}</div>
    </div>
  </div>
</ng-template>
